import { timestampToDate } from '../../helper/time'

export const panels = [
	{
		title: 'Users',
		icon: '/assets/users.svg',
	},
	{
		title: 'Sessions',
		icon: '/assets/Sessions.svg',
	},
	{
		title: 'Posts',
		icon: '/assets/posts.svg',
	},
	{
		title: 'Interactions',
		icon: '/assets/interaction.svg',
	},
	{
		title: 'Sales',
		icon: '/assets/Sale.svg',
	},
];

export const chartOptions = (data) => {
	return {
		chart: {
			type: 'bar',
			stacked: true,
			toolbar: {
				show: false,
			},
			height: 480,
			width: '100%',
			zoom: {
				enabled: false,
			},
		},
		dataLabels: {
			enabled: false,
		},
		plotOptions: {
			bar: {
				horizontal: false,
				rangeBarOverlap: false,
				dataLabels: {
					position: 'top',
				},
			},
		},
		fill: {
			opacity: 1,
		},
		markers: {
			size: 0,
		},
		yaxis: {
			labels: {
				style: {
					colors: '#8e8da4',
				},
				offsetX: 0,
			},
			axisBorder: {
				show: false,
			},
			axisTicks: {
				show: false,
			},
		},
		xaxis: {
			type: 'category',
			labels: {
				showDuplicates: false,
				format: 'dd/MM/yy',
				show: true,
			},
			categories: data.map(d => timestampToDate(d.ts)),
		},
		tooltip: {
			shared: true,
			followCursor: true,
			style: {
				borderRadius: '20px',
				fontSize: '14px',
				fontFamily: 'Poppins',
			},
		},
		legend: {
			position: 'right',
			offsetY: 20,
			itemMargin: {
				horizontal: 4,
				vertical: 4,
			},
		},
	}
};

